export function setTimeToNoonUTC(date: Date): Date | undefined {
  if (!date) {
    return undefined;
  }
  const utcDate = new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
  utcDate.setUTCHours(12, 0, 0, 0);
  return utcDate;
}
